var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputerSaleHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.006 512.006",
    style: {
      enableBackground: "new 0 0 512.006 512.006"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256.003,
    cy: 256.003,
    r: 256.003
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M26.764,370.041h458.489c-41.941,84.148-128.83,141.965-229.245,141.965 C155.6,512.006,68.706,454.189,26.764,370.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#596366"
    },
    d: "M34.636,134.142h275.902c9.064,0,16.484,7.414,16.484,16.478v169.958H18.158V150.619 C18.158,141.555,25.572,134.142,34.636,134.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0081ED"
    },
    d: "M29.348,309.387h286.477V150.619c0-2.891-2.403-5.288-5.288-5.288H34.636 c-2.891,0-5.288,2.403-5.288,5.288V309.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9C9C9C"
    },
    d: "M327.022,320.577v18.026c0,9.064-8.179,16.478-18.17,16.478H36.322 c-9.992,0-18.164-7.414-18.164-16.478v-18.026H327.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6CBD6"
    },
    d: "M172.59,331.442c3.132,0,5.673,2.542,5.673,5.673c0,3.132-2.542,5.673-5.673,5.673 s-5.673-2.542-5.673-5.673C166.917,333.984,169.458,331.442,172.59,331.442z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E4E7ED"
    },
    points: "208.208,381.014 234.412,389.41 110.762,389.41 131.901,381.014 131.901,355.087  208.208,355.087 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ECF0F1"
    },
    points: "131.901,381.014 208.208,381.014 234.412,389.41 234.412,393.029 172.59,393.029  110.762,393.029 110.762,389.41 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C6CBD6"
    },
    points: "131.901,355.087 208.208,355.087 208.208,381.014 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B7F9E"
    },
    d: "M355.665,116.64H487.91c3.276,0,5.95,2.68,5.95,5.95v264.483c0,3.276-2.674,5.95-5.95,5.95H355.665 c-3.27,0-5.95-2.674-5.95-5.95V122.59C349.715,119.32,352.395,116.64,355.665,116.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D718F"
    },
    d: "M493.258,389.669c-0.97,1.987-3.011,3.361-5.354,3.361H355.665c-2.349,0-4.39-1.373-5.354-3.361 H493.258z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5D718F"
    },
    points: "364.259,116.64 479.309,116.64 479.309,246.578 364.259,246.578  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6B7F9E"
    },
    points: "373.179,203.016 470.384,203.016 470.384,233.436 373.179,233.436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6B7F9E"
    },
    points: "373.179,169.085 470.384,169.085 470.384,199.499 373.179,199.499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#6B7F9E"
    },
    points: "373.179,129.534 470.384,129.534 470.384,144.741 373.179,144.741  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5D718F"
    },
    points: "373.179,372.504 470.384,372.504 470.384,377.804 373.179,377.804  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5D718F"
    },
    points: "373.179,361.447 470.384,361.447 470.384,366.747 373.179,366.747  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA0404"
    },
    d: "M421.781,308.478c4.384,0,7.932,3.553,7.932,7.932c0,4.384-3.553,7.938-7.932,7.938 c-4.384,0-7.938-3.553-7.938-7.938C413.844,312.031,417.397,308.478,421.781,308.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7069"
    },
    d: "M421.781,336.417c2.283,0,4.132,1.849,4.132,4.132c0,2.283-1.849,4.132-4.132,4.132 c-2.283,0-4.132-1.849-4.132-4.132C417.65,338.266,419.499,336.417,421.781,336.417z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerSaleHover);
export default __webpack_public_path__ + "static/media/ComputerSaleHover.667660569ca98d27df3f8e2f9bcc0df9.svg";
export { ForwardRef as ReactComponent };